<template>
    <BasePage style="border-radius: 0; overflow: hidden">
        <SotHeader v-if="!tabbed" :params="params" />
        <div
            ref="pageMainDiv"
            id="pageMainDiv"
            @scroll="onScroll"
            :class="{ 'column q-gutter-y-sm no-wrap': true }"
            :style="{ 'overflow': pageOverflow, 'height': pageHeight, 'margin-top': marginTop, 'padding-bottom': '0' }"
        >
            <!--
            <q-scroll-observer @scroll="onScroll" />
            -->
            <div v-show="loading" class="col flex flex-center">
                <q-circular-progress indeterminate color="primary" size="md" />
            </div>
            <div v-show="error" class="col column flex flex-center">
                <div class="items-center column q-gutter-y-md">
                    <div>Страница не найдена</div>
                    <div class="text-grey text-caption">{{ params }}</div>
                    <q-btn label="Назад" @click="reload" no-caps />
                </div>
            </div>

            <div v-if="components[0]" class="fit">
                <div v-if="components[0].params.to === 'video' && components[0].params.type === 'image'" class="column fit" style="overflow: hidden">
                    <div class="col-auto" style="z-index: 99">
                        <component
                            v-show="!error && allow(components[0].params)"
                            v-bind:is="components[0].name"
                            :params="components[0].params"
                            :view="components[0]"
                            :tabbed="tabbed"
                            :style="{ 'padding-left': paddingHoriz(components[0]), 'padding-right': paddingHoriz, 'width': $q.platform.is.mobile ? '100vw' : '400px', 'padding-bottom': '20px' }"
                            :page="page"
                        ></component>
                    </div>
                    <div class="col" style="margin-top: -28px">
                        <q-scroll-area ref="scrollArea" class="fit" @scroll="onScroll">
                            <div style="height: 25px;"></div>
                            <component
                                v-for="(component, index) in components.slice(1)"
                                :key="index"
                                v-show="!error && allow(component.params)"
                                v-bind:is="component.name"
                                :params="component.params"
                                :view="component"
                                :tabbed="tabbed"
                                :style="{ 'padding-left': paddingHoriz(component), 'padding-right': paddingHoriz, 'max-width': '370px' }"
                                :page="page"
                            ></component>
                            <div style="height: 20px;"></div>
                        </q-scroll-area>
                    </div>
                </div>
                <div v-else style="overflow: hidden" class="q-gutter-y-sm">
                    <component
                        v-for="(component, index) in components"
                        :key="index"
                        v-show="!error && allow(component.params)"
                        v-bind:is="component.name"
                        :params="component.params"
                        :view="component"
                        :tabbed="tabbed"
                        :style="{ 'padding-left': paddingHoriz(component), 'padding-right': paddingHoriz }"
                        :page="page"
                    >
                    </component>
                </div>
            </div>
        </div>
        <!--
        <q-img v-show="!tabbed" src="~assets/ui/sot-bottom.svg" width="26px" style="z-index: 99; position: absolute; bottom: 30px; right: 40px;" />
        -->
    </BasePage>
</template>

<script>
import SotHeader from 'components/ui/design/SotHeader';
import SotButton from 'components/ui/design/SotButton';
import BasePage from 'pages/BasePage';
import pageScrollSaver from 'src/mixins/pageScrollSaverMixin';

const moment = require('moment');

export default {
    name: 'Page',
    components: { BasePage, SotButton, SotHeader },
    mixins: [pageScrollSaver],
    props: {
        params: {
            type: Object,
            default: undefined,
        },
        tabbed: {
            type: Boolean,
            default: false,
        },
    },
    mounted () {
        this.init();
    },
    computed: {
        user () {
            return this.$store.state.pages.user;
        },
        statePage () {
            return this.$store.state.pages.page;
        },
        isBackVisible () {
            let visible = this.params && this.params.uuid !== 'root';
            visible = visible && this.page && this.page.back_button_visible === '1';
            return visible;
        },
        pageHeight () {
            /*
            if (this.$q.platform.is.mobile) {
                return 'calc(100vh - 70px)';
            }
            if (this.tabbed) {
                return 'calc(100vh - 150px)';
            }
            return 'calc(100vh - 30px)';
             */
            return '100%';
        },
        marginTop () {
            if (this.tightHeader === '1') {
                return '44px';
            }
            if (this.tabbed) {
                return '0px';
            }
            return '110px';
        },
    },
    watch: {
        statePage (v) {
            setTimeout(() => {
                this.restoreScroll(true, v);
            }, 300);
        },
    },
    data () {
        return {
            page: undefined,
            components: [],
            error: undefined,
            loading: false,
            tightHeader: '0',
            timer: undefined,
            pageOverflow: 'auto',
        };
    },
    methods: {
        init () {
            const { uuid } = this.params;
            this.load(uuid);
            // Псеводреактивность отключили
            // this.startUIWatchTimer();
        },
        load (uuid) {
            this.error = undefined;
            this.loading = true;
            this.$factory.loadPage(uuid).then((page) => {
                this.error = !page;
                this.page = page;
                this.tightHeader = page.tight_header;
                this.checkHashtags(page.add_hashtag_to_user);
                this.$factory.loadViews(uuid).then((components) => {
                    this.components = components;
                    // this.error = components.length === 0;

                    const firstComponent = this.components[0];
                    if (firstComponent) {
                        if (firstComponent.params.type === 'image' && firstComponent.params.to === 'video') {
                            this.pageOverflow = 'hidden';
                        }
                    }
                    this.loading = false;
                });
            });
        },
        checkHashtags (tags) {
            if (!tags) { return; }
            if (tags === '') { return; }
            let userTags = this.user.hashtags;

            if (userTags) {
                const userTagsArray = userTags.split(/#/g).map((e) => e.trim());
                const viewTagsArray = tags.split(/#/g).map((e) => e.trim());

                for (let i = 0; i < viewTagsArray.length; i += 1) {
                    const tag = viewTagsArray[i];
                    if (tag.length > 0) {
                        const index = userTagsArray.indexOf(tag);
                        if (index < 0) {
                            userTags = `${userTags} #${tag}`;
                        }
                    }
                }
                const u = { ...this.user };
                u.hashtags = userTags;
                this.$store.commit('pages/setUser', u);
                this.$db.users.updateUserHashtags(this.user.id, userTags);
            } else {
                const u = { ...this.user };
                u.hashtags = tags;
                this.$store.commit('pages/setUser', u);
                this.$db.users.updateUserHashtags(this.user.id, tags);
            }
        },
        /*
        startUIWatchTimer () {
            clearTimeout(this.timer);
            setTimeout(() => {
                this.checkUI();
                this.startUIWatchTimer();
            }, 1000 * 60);
        },
        checkUI () {
            const { uuid } = this.params;
            this.$factory.loadViews(uuid).then((components) => {
                for (let i = 0; i < this.components.length; i += 1) {
                    const c = this.components[i];
                    const remoteComponent = components.filter((e) => +e.id === +c.id)[0];
                    if (remoteComponent) {
                        if (remoteComponent.params.hashtags !== c.params.hashtags) {
                            c.params.hashtags = remoteComponent.params.hashtags;
                        }
                        if (remoteComponent.params.visibility !== c.params.visibility) {
                            c.params.visibility = remoteComponent.params.visibility;
                        }
                    }
                }

                // todo: - сделать чтобы не по количеству определялось изменение компонент, а по новым или отсутствующим uuid или id
                // Добавим новые появившиеся компоненты и удалим те которые удалили в админке
                if (components.length !== this.components.length) {
                    this.components = components;
                }
            });
        },
        */
        reload () {
            this.$pages.back();
        },
        allow (params) {
            if (params.visibility) {
                if (params.visibility === 'registered') {
                    return this.user !== undefined;
                }
                if (params.visibility === 'not-registered') {
                    return this.user === undefined;
                }
                if (params.visibility === 'hidden') {
                    return false;
                }
                if (params.visibility === 'hashtags') {
                    if (!this.user) {
                        return false;
                    }
                    const userTags = this.user.hashtags;
                    const viewTags = params.hashtags;

                    if (userTags && viewTags) {
                        const userTagsArray = userTags.split(/#/g).map((e) => e.trim());
                        const viewTagsArray = viewTags.split(/#/g).map((e) => e.trim());

                        for (let i = 0; i < viewTagsArray.length; i += 1) {
                            const tag = viewTagsArray[i];
                            if (tag.length > 0) {
                                const index = userTagsArray.indexOf(tag);
                                if (index >= 0) {
                                    return true;
                                }
                            }
                        }
                    }
                    return false;
                }
                if (params.visibility === 'debug') {
                    const { isDebugMode } = this.$store.state.pages;
                    return this.$route.query.debug === '1' || isDebugMode;
                }
            }
            if (params.to === 'create_cert3' && params.cert_active_date) {
                // const m = moment(params.cert_active_date, 'DD.MM.YYYY HH:mm').zone('+03:00');
                const m = moment(params.cert_active_date, 'DD.MM.YYYY HH:mm').utcOffset('+03:00');
                // на сервере время по мск хранится, а нужно его привести к текущему часовому поясу клиента
                return moment().isAfter(m);
            }
            return true;
        },
        paddingHoriz (component) {
            // для кнопки-картинки не делаем отступы по сторонам
            if (component.name === 'Button' && component.params.type === 'image') {
                return '0px';
            }
            if (this.tabbed) {
                return '0';
            }
            return '15px';
        },
    },
};
</script>

<style lang="scss">
    .tabbed {
        margin-top: 50px;
    }
    .tight-header {
        margin-top: 44px;
    }
    .normal-header {
        margin-top: 72px;
    }
</style>
